<bl-modal-content #content [title]="'画面動作設定'">
  <div body class="mainte-detail-container">
    <table class="table table-bordered">
      <tr>
        <td class="td_Width">説明</td>
        <td>
          各伝票をクリックした場合の遷移先を選択してください。
        </td>
      </tr>
    </table>
    <ng-container *ngFor="let config of displayConfigs; let i = index">
      <div class="mainte-title">{{ config.productCodeName }}</div>
      <table class="table table-bordered">
        <tr>
          <td class="td_Width">{{ config.firstName }}</td>
          <td>
            <bl-radio-group
              #firstSlipNavigationDiv
              [value]="getFirstSlipValue(config)"
              (valueChange)="setFirstSlipValue(config, $event)"
              groupType="inline"
              [items]="config.firstNavItems">
            </bl-radio-group>
          </td>
        </tr>
        <tr>
          <td class="td_Width">{{ config.secondName }}</td>
          <td>
            <bl-radio-group
              #secondSlipNavigationDiv
              [value]="getSecondSlipValue(config)"
              (valueChange)="setSecondSlipValue(config, $event)"
              groupType="inline"
              [items]="config.secondNavItems">
          </bl-radio-group>
          </td>
        </tr>
        <tr *ngIf="config.thirdName">
          <td class="td_Width">{{ config.thirdName }}</td>
          <td>
            <bl-radio-group
              #thirdSlipNavigationDiv
              [value]="getThirdSlipValue(config)"
              (valueChange)="setThirdSlipValue(config, $event)"
              groupType="inline"
              [items]="config.thirdNavItems">
            </bl-radio-group>
          </td>
        </tr>
        <tr *ngIf="config.receptionName">
          <td class="td_Width">{{ config.receptionName }}</td>
          <td>
            <bl-radio-group
              #receptionNavigationDiv
              [value]="getReceptionValue(config)"
              (valueChange)="setReceptionValue(config, $event)"
              groupType="inline"
              [items]="config.receptionNavItems">
            </bl-radio-group>
          </td>
        </tr>
      </table>
    </ng-container>
    <table class="table table-bordered last-table">
      <tr>
        <td style="border: 0;">※画面動作設定はご利用のアカウントごとに保存されます。</td>
      </tr>
    </table>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/feature/biz-menu-page-screen-action-setting-modal/biz-menu-page-screen-action-setting-modal.component.html